import svg4everybody from 'svg4everybody';
import $ from 'jquery';
import 'slick-carousel';
import 'social-likes';
import 'ion-rangeslider';
import Cookies from 'js-cookie';
import 'jquery-colorbox';
import 'jquery.scrollto';
import 'jquery-form';


$(() => {
	svg4everybody();

	$.extend($.colorbox.settings, {
		current: "{current} / {total}",
		previous: "&#10229;",
		next: "&#10230;",
		close: "&#10005;",
		xhrError: "Не удалось загрузить содержимое.",
		imgError: "Не удалось загрузить изображение.",
		slideshowStart: "начать слайд-шоу",
		slideshowStop: "остановить слайд-шоу",
		opacity: 0.2
	});
});

(function (pType) {
	$(function () {

		const $window = $(window);

		if (typeof window.langEn === 'undefined') {
			window.langEn = false;
		}
		window.currUsd = $('body').hasClass('_curr_USD');

		window.sys = {};

		window.sys.checkIsDesktop = function () {
			return $window.width() > 1160;
		};
		window.sys.checkIsTablet = function () {
			return $window.width() > 800 && $window.width() <= 1160;
		};
		window.sys.checkIsMobile = function () {
			return $window.width() <= 800;
		};

		const formatMoney = function (number, decPlaces, decSep, thouSep) {
			decPlaces = isNaN(decPlaces = Math.abs(decPlaces)) ? 2 : decPlaces;
			decSep = typeof decSep === 'undefined' ? '.' : decSep;
			thouSep = typeof thouSep === 'undefined' ? ',' : thouSep;

			const sign = number < 0 ? '-' : '';
			let i = String(parseInt(number = Math.abs(Number(number) || 0).toFixed(decPlaces)));
			let j = i.length;
			j = j > 3 ? (j % 3) : 0;

			return sign +
				(j ? i.substr(0, j) + thouSep : '') +
				i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thouSep) +
				(decPlaces ? decSep + Math.abs(number - i).toFixed(decPlaces).slice(2) : '');
		};

		const $modals = $('.modal');
		const $modalsBackdrop = $modals.find('.modal_backdrop');

		$modals.find('._modal_close').click(function () {
			$(this).closest('.modal_container').hide();
			$modalsBackdrop.hide();
			$modals.hide();

			$('body').removeClass('modal_open_body');

			return false;
		});

		const showModalInfo = function (header, message) {
			if ( !$modals.length) {
				return;
			}

			const $modalInfo = $modals.find('.modal__info');
			$modalInfo.find('.modal_header h1').text(header);
			$modalInfo.find('.modal_message').text(message);

			$modals.show();
			$modalsBackdrop.show();
			$modalInfo.show();
		};


		const showModalCallback = function () {
			if ( !$modals.length) {
				return;
			}

			const $modalCallback = $modals.find('.modal__callback');

			$modals.show();
			$modalsBackdrop.show();
			$modalCallback.show();
		};

		const showModal = function (modalClass) {
			if ( !$modals.length) {
				return;
			}

			const $modalPopup = $modals.find('.' + modalClass);

			$('body').addClass('modal_open_body');

			$modals.show();
			$modalsBackdrop.show();
			$modals.find('.modal_container').hide();
			$modalPopup.show();
		};


		$('.handler-open-callback-popup').click(function () {
			showModalCallback();
			return false;
		});

		$('.handler-open-modal').click(function () {
			const $this = $(this);
			if ($this.attr('rel')) {
				showModal($this.attr('rel'));
			}
			return false;
		});


		const menuOffset = $('.header_menu_first > li').first().offset().top + $('.header_menu_first li').first().height();
		const menuPadding = $('.header').height() - menuOffset + 1;
		//window.console.log(menuOffset);
		if (window.sys.checkIsMobile()) {
			$('.handler-open-mobile-menu').click(function () {
				const $this = $(this);
				if ($this.hasClass('open')) {
					$this.removeClass('open');
					$('.header_menu').slideUp();
				}else {
					$this.addClass('open');
					$('.header_menu').slideDown();
				}
				return false;
			});

			$('.header_menu_first > li > a').click(function () {
				const $this = $(this).closest('li');
				const $submenu = $this.find('.header_menu_wrapper');

				if ($this.hasClass('open')) {
					$this.removeClass('open');
					$submenu.slideUp();
				} else {
					$this.addClass('open');
					$submenu.slideDown();
				}

				return false;
			});
		}else {
			$('.header_menu_first > li').each(function (index, menuItem) {
				const $menuItem = $(menuItem);
				if ($menuItem.find('.header_menu_wrapper').length) {
					$menuItem.find('.header_menu_wrapper').css({
						'padding-top': menuPadding + 'px',
						top: menuOffset + 'px'
					});
				}
			});
		}

		$('.handler-open-search').click(function () {
			$('.header_search').toggleClass('open');
			if ($('.header_search').hasClass('open')) {
				setTimeout(function () {
					$('.header_search').find('input[type=text]').focus();
				}, 300);
			}
			return false;
		});


		// SIZES GUIDE
		(function () {
			const $modalSizes = $modals.find('.modal__table_size');
			const $modalGuide = $modals.find('.modal__sizes_guide');

			const GUIDE_TABLES = {};

			GUIDE_TABLES.suit_man = [
				{size: 'S',		height_f: 165, height_t: 175, weight_f: 60, weight_t: 70, v_breast_f: 100, v_breast_t: 111, v_hips_f: 98, v_hips_t: 114},
				{size: 'M', 	height_f: 168, height_t: 182, weight_f: 65, weight_t: 75, v_breast_f: 104, v_breast_t: 115, v_hips_f: 102, v_hips_t: 118},
				{size: 'L', 	height_f: 175, height_t: 187, weight_f: 75, weight_t: 90, v_breast_f: 108, v_breast_t: 119, v_hips_f: 106, v_hips_t: 122},
				{size: 'XL', 	height_f: 180, height_t: 192, weight_f: 85, weight_t: 99, v_breast_f: 112, v_breast_t: 123, v_hips_f: 110, v_hips_t: 126},
				{size: 'XXL', 	height_f: 185, height_t: 197, weight_f: 95, weight_t: 105, v_breast_f: 116, v_breast_t: 127, v_hips_f: 114, v_hips_t: 130}
			];

			GUIDE_TABLES.suit_woman = [
				{size: 'XXS',	height_f: 150, height_t: 160, weight_f: 40, weight_t: 50, v_breast_f: 85, 	v_breast_t: 98, 	v_hips_f: 88, v_hips_t: 98},
				{size: 'XS',	height_f: 158, height_t: 168, weight_f: 47, weight_t: 57, v_breast_f: 90, 	v_breast_t: 102, 	v_hips_f: 92, v_hips_t: 102},
				{size: 'S',		height_f: 164, height_t: 174, weight_f: 56, weight_t: 65, v_breast_f: 95, 	v_breast_t: 106, 	v_hips_f: 96, v_hips_t: 106},
				{size: 'M',		height_f: 168, height_t: 178, weight_f: 64, weight_t: 73, v_breast_f: 98,	v_breast_t: 110, 	v_hips_f: 100, v_hips_t: 110},
				{size: 'L',		height_f: 175, height_t: 185, weight_f: 70, weight_t: 80, v_breast_f: 103,	v_breast_t: 114,	v_hips_f: 104, v_hips_t: 114}
			];

			GUIDE_TABLES.suit_kids = [
				{size: '140',	height_f: 125, height_t: 135, weight_f: 0, weight_t: 0, v_breast_f: 80,	v_breast_t: 92, v_hips_f: 80, v_hips_t: 92},
				{size: '146',	height_f: 131, height_t: 141, weight_f: 0, weight_t: 0, v_breast_f: 84,	v_breast_t: 96, v_hips_f: 84, v_hips_t: 96},
				{size: '152',	height_f: 137, height_t: 147, weight_f: 0, weight_t: 0, v_breast_f: 88,	v_breast_t: 100,v_hips_f: 88, v_hips_t: 100},
				{size: '158',	height_f: 143, height_t: 153, weight_f: 0, weight_t: 0, v_breast_f: 92,	v_breast_t: 104,v_hips_f: 92, v_hips_t: 104},
				{size: '164',	height_f: 149, height_t: 159, weight_f: 0, weight_t: 0, v_breast_f: 96,	v_breast_t: 108,v_hips_f: 96, v_hips_t: 108}
			];

			$('.handler-open-modal-sizes').click(function () {
				showModal('modal__table_size');

				$modalSizes.find('.modal_cnt__logo_guide h5').text('');
				$modalSizes.find('.modal_cnt__big_header').show().find('h1').text(window.langEn ? 'Sizes table' : 'Таблица размеров');

				$modalSizes.find('.modal_cnt__size_sex').show();
				$modalSizes.find('.modal_buttons .handler-open-modal').show();

				$modalSizes.find('.modal_cnt__size_recommend').hide();
				$modalSizes.find('.modal_cnt__size_different').hide();
				$modalSizes.find('.modal_cnt__size_error').hide();
				$modalSizes.find('.modal_buttons ._modal_back').hide();
				$modalSizes.find('.modal_buttons ._modal_close').hide();

				return false;
			});

			$modalGuide.find('.handler-guide-next').click(function () {
				const $form = $modalGuide.find('.modal_cnt__params_form');

				let error = false;
				$form.find('.form_input.required:visible').each(function (index, input) {
					const $input = $(input);
					const value = $input.find('input[type=text], input[type=number], textarea, select').first().val();

					if ( !$input.find('> span').length) {
						$input.append('<span>');
					}

					if ( !value.trim().length) {
						error = true;
						$input.find('> span').text(window.langEn ? 'Field is required' : 'Поле обязательно для заполнения');
						$input.addClass('error');
					}
				});

				if (error) {
					return false;
				}

				let height = parseInt($form.find('input[name="height"]').val());
				let weight = parseInt($form.find('input[name="weight"]').val());
				let breast = parseInt($form.find('input[name="breast"]').val());
				let hips = parseInt($form.find('input[name="hips"]').val());

				height = isNaN(height) ? 0 : height;
				weight = isNaN(weight) ? 0 : weight;
				breast = isNaN(breast) ? 0 : breast;
				hips = isNaN(hips) ? 0 : hips;

				const sisez = window.guideSizesTable ? GUIDE_TABLES[ window.guideSizesTable ] : GUIDE_TABLES.suit_man;

				let sizeMain = '';
				let sizeAdditional = '';

				let errorMessage = '';
				if (height < sisez[0].height_f || height > sisez[sisez.length-1].height_t ||
					weight < sisez[0].weight_f || weight > sisez[sisez.length-1].weight_t
				) {
					errorMessage = window.langEn ?
						'Failed to calculate the size for the specified parameters, or entered incorrect values. We recommend referring to the size table.' :
						'Не удалось вычислить размер по заданным параметрам, либо введены некорректные значения. Рекомендуем обратиться к таблице размеров.';
				}

				for (let i = 0; i < sisez.length; i++) {
					const iterSize = sisez[i];
					if (height >= iterSize.height_f && height <= iterSize.height_t &&
						weight >= iterSize.weight_f && weight <= iterSize.weight_t) {
						sizeMain = iterSize.size;
						break;
					}
				}

				if (!sizeMain) {
					errorMessage = window.langEn ?
						'Failed to calculate the size for the specified height and weight parameters. We recommend referring to the size table.' :
						'Не удалось вычислить размер по заданным параметрам роста и веса. Рекомендуем обратиться к таблице размеров.';
				} else {
					if (breast && hips) {
						for (let i = 0; i < sisez.length; i++) {
							const iterSize = sisez[i];
							if (breast >= iterSize.v_breast_f && breast <= iterSize.v_breast_t &&
								hips >= iterSize.v_hips_f && hips <= iterSize.v_hips_t) {
								sizeAdditional = iterSize.size;
								if (sizeAdditional === sizeMain) {
									break;
								}
							}
						}
					}
				}

				showModal('modal__table_size');

				$modalSizes.find('.modal_cnt__logo_guide h5').text(window.langEn ? 'Size helper' : 'Гид по размерам');
				$modalSizes.find('.modal_cnt__big_header').hide();

				$modalSizes.find('.modal_cnt__size_sex').hide();
				$modalSizes.find('.modal_buttons .handler-open-modal').hide();

				$modalSizes.find('.modal_buttons ._modal_back').show();
				$modalSizes.find('.modal_buttons ._modal_close').show();

				if (errorMessage) {
					$modalSizes.find('.modal_cnt__size_recommend').hide();
					$modalSizes.find('.modal_cnt__size_different').hide();
					$modalSizes.find('.modal_cnt__size_error').show().text(errorMessage);
				} else {
					$modalSizes.find('.modal_cnt__size_error').hide();
					$modalSizes.find('.modal_cnt__size_recommend').show();
					$modalSizes.find('.modal_cnt__size_recommend_height').text(sizeMain);
					if (sizeAdditional) {
						$modalSizes.find('.modal_cnt__size_recommend_volume').text(sizeAdditional);
						if (sizeMain !== sizeAdditional) {
							$modalSizes.find('.modal_cnt__size_different').show();
						}
					} else {
						$modalSizes.find('.modal_cnt__size_recommend_volume').html('&mdash;');
					}
				}
			});
		})();



		// PAGE SLIDERS
		(function () {
			if ($('.main-slider').length) {
				const $sliderContainer = $('.main-slider');

				$('.main-slider_list').slick({
					autoplay: $sliderContainer.data('autoplay') == '1',
					autoplaySpeed: $sliderContainer.data('autoplayspeed') ? $sliderContainer.data('autoplayspeed') : 3000,
					infinite: $sliderContainer.data('infinite') == '1',
					speed: $sliderContainer.data('speed') ? $sliderContainer.data('speed') : 300,

					slidesToShow: 1,
					slidesToScroll: 1,
					dots: false,
					arrows: ! window.sys.checkIsMobile(),

					prevArrow: $('.main-slider_container .slider-controls_arrow_prev'),
					nextArrow: $('.main-slider_container .slider-controls_arrow_next')
					//appendDots: $('.main-top_carousel_container .slider-controls_dots_container'),
					//dotsClass: 'slider-controls_dots'
				});
			}

			if ($('.main-popular').length) {
				$('.main-popular_nav a').each(function (index, element) {
					const $element = $(element);
					if ( !$('.main-popular_container.__rel' + $element.attr('rel') + ' .main-popular_list_item').length) {
						$element.closest('li').remove();
					}
				});
				$('.main-popular_nav a:visible').click(function () {
					$('.main-popular_container').hide();
					$('.main-popular_nav a').removeClass('active');

					const $this = $(this);
					$this.addClass('active');

					const $container = $('.main-popular_container.__rel' + $this.attr('rel'));
					$container.show();
					if ( !$container.hasClass('__slick_inited')) {
						if ( !window.sys.checkIsMobile()) {
							$container.find('.main-popular_list').slick({
								centerMode: true,
								centerPadding: '0px',
								slidesToShow: 3,
								dots: true,

								prevArrow: $container.find('.slider-controls_arrow_prev'),
								nextArrow: $container.find('.slider-controls_arrow_next'),
								appendDots: $container.find('.slider-controls_dots_container'),
								dotsClass: 'slider-controls_dots'
							});
						}else {
							$container.find('.main-popular_list').slick({
								slidesToShow: 1,
								slidesToScroll: 1,
								dots: true,
								arrows: true,

								prevArrow: $container.find('.slider-controls_arrow_prev'),
								nextArrow: $container.find('.slider-controls_arrow_next'),
								appendDots: $container.find('.slider-controls_dots_container'),
								dotsClass: 'slider-controls_dots'
							});
						}
						$container.addClass('__slick_inited');
					}

					return false;
				}).first().trigger('click');
			}

			if ($('.product_media').length) {
				if (window.sys.checkIsMobile()) {
					$('.product_media').slick({
						slidesToShow: 1,
						slidesToScroll: 1,
						dots: false,
						arrows: true,

						prevArrow: $('.product_media_container .slider-controls_arrow_prev'),
						nextArrow: $('.product_media_container .slider-controls_arrow_next')
					});
				}
			}

			if ($('.similar').length) {
				if ( !window.sys.checkIsMobile()) {
					$('.similar_list').slick({
						centerMode: false,
						centerPadding: '0px',
						slidesToShow: 3,
						dots: true,

						prevArrow: $('.similar_container .slider-controls_arrow_prev'),
						nextArrow: $('.similar_container .slider-controls_arrow_next'),
						appendDots: $('.similar_container .slider-controls_dots_container'),
						dotsClass: 'slider-controls_dots'
					});
				}else {
					$('.similar_list').slick({
						slidesToShow: 1,
						slidesToScroll: 1,
						dots: true,
						arrows: true,

						prevArrow: $('.similar_container .slider-controls_arrow_prev'),
						nextArrow: $('.similar_container .slider-controls_arrow_next'),
						appendDots: $('.similar_container .slider-controls_dots_container'),
						dotsClass: 'slider-controls_dots'
					});
				}
			}

			if ($('.cart_present').length) {
				if ( !window.sys.checkIsMobile()) {
					$('.cart_present_list').slick({
						centerMode: false,
						centerPadding: '0px',
						slidesToShow: 3,
						dots: true,

						prevArrow: $('.cart_present_container .slider-controls_arrow_prev'),
						nextArrow: $('.cart_present_container .slider-controls_arrow_next'),
						appendDots: $('.cart_present_container .slider-controls_dots_container'),
						dotsClass: 'slider-controls_dots'
					});
				}else {
					$('.cart_present_list').slick({
						slidesToShow: 1,
						slidesToScroll: 1,
						dots: true,
						arrows: true,

						prevArrow: $('.cart_present_container .slider-controls_arrow_prev'),
						nextArrow: $('.cart_present_container .slider-controls_arrow_next'),
						appendDots: $('.cart_present_container .slider-controls_dots_container'),
						dotsClass: 'slider-controls_dots'
					});
				}
			}
		})();

		// NEWS
		(function () {
			$('.news .news_paging_summary ._current').text($('.news .news_list .news-item').length);

			$('.handler-news-load-more').click(function () {
				const $this = $(this);
				if ($this.hasClass('_waiting')) {
					return false;
				}

				$this.addClass('_waiting').data('initial-text', $this.text()).text(window.langEn ? 'Pls wait...' : 'Подождите...');
				$.get($this.attr('href'), {}, function (result, a, b, c) {
					const $result = $('<div>').html(result.replace(/^[\s\S]*<body.*?>|<\/body>[\s\S]*$/ig, ''));
					$('.news .news_list').append($result.find('.news .news_list .news-item'));
					if ($result.find('.news .news_paging_more ._tonext_more').length) {
						$this.attr({
							href: $result.find('.news .news_paging_more ._tonext_more').attr('href')
						}).removeClass('_waiting').text($this.data('initial-text'));
					}else {
						$this.hide();
					}
					$('.news .news_paging_summary ._current').text($('.news .news_list .news-item').length);
				}, 'html');
				return false;
			});
		})();


		// CATALOG
		(function () {
			const $catalogSort = $('.catalog_sort');
			$catalogSort.find('.catalog_sort_header').click(function () {
				$catalogSort.toggleClass('_open');
			});
			if ($catalogSort.find('.catalog_sort_items a.active').length) {
				$catalogSort.find('.catalog_sort_header span').text($catalogSort.find('.catalog_sort_items a.active').text());
			}

			$('.catalog .catalog_paging_summary ._current').text($('.catalog .catalog_list .catalog-item').length);

			$('.handler-catalog-load-more').click(function () {
				const $this = $(this);
				if ($this.hasClass('_waiting')) {
					return false;
				}

				$this.addClass('_waiting').data('initial-text', $this.text()).text(window.langEn ? 'Pls wait...' : 'Подождите...');
				$.get($this.attr('href'), {}, function (result, a, b, c) {
					const $result = $('<div>').html(result.replace(/^[\s\S]*<body.*?>|<\/body>[\s\S]*$/ig, ''));
					$('.catalog .catalog_list').append($result.find('.catalog .catalog_list .catalog-item'));
					if ($result.find('.catalog .catalog_paging_more ._tonext_more').length) {
						$this.attr({
							href: $result.find('.catalog .catalog_paging_more ._tonext_more').attr('href')
						}).removeClass('_waiting').text($this.data('initial-text'));
					}else {
						$this.hide();
					}
					$('.catalog .catalog_paging_summary ._current').text($('.catalog .catalog_list .catalog-item').length);
				}, 'html');
				return false;
			});

			$(document).on('click', '.catalog-item .handler-add-to-cart', function () {
				const $this = $(this);

				if ($this.closest('.catalog-item').hasClass('catalog-item_small')) {
					if ($this.closest('.cart_present').length && $this.closest('.cart_present').hasClass('_waiting')) {
						return false;
					}
				}

				if ($this.hasClass('_completed')) {
					return true;
				}
				if ($this.hasClass('_waiting')) {
					return false;
				}

				const itemId = $this.data('item-id');
				if (itemId) {
					$this.addClass('_waiting');
					$this.data('initial-text', $this.text()).text(window.langEn ? 'Pls wait...' : 'Подождите...');

					if ($this.closest('.catalog-item').hasClass('catalog-item_small')) {
						if ($this.closest('.cart_present').length) {
							$this.closest('.cart_present').addClass('_waiting');
						}
					}

					let options = {};

					const selectedSize = $this.data('opt-value');
					if (selectedSize) {
						options[$this.closest('._opt_block').data('opt-name')] = selectedSize;
					}

					const $controlList = $this.closest('.catalog-item_controls_list');
					$controlList.empty().append(
						$('<span>').text(window.langEn ? 'Pls wait...' : 'Подождите...')
					);

					basket.putElement(itemId, options, function (result) {
						if ($controlList.closest('.catalog-item').hasClass('catalog-item_small')) {
							window.location.reload();
							return;
						}

						//$this.removeClass('_waiting').addClass('_completed');
						$controlList.empty().append(
							$('<a>').attr({
								href: '/cart/',
								title: window.langEn ? 'Go to shopping cart' : 'Перейти в корзину'
							}).text(window.langEn ? 'Added to cart' : 'В корзине')
						);

						$('.header_tools_list ._cart span').show().text(result.summary.amount);
					});
				}

				return false;
			});

			$(document).on('click', '.catalog-item .handler-product-remove-from-favorite', function () {
				const $this = $(this);
				if ($this.hasClass('_waiting')) {
					return false;
				}

				const itemId = $this.data('item-id');
				if (itemId) {
					$this.addClass('_waiting').text(window.langEn ? 'Pls wait...' : 'Подождите...');

					$.get('/_sys/remove-from-bookmarks/', {
						page_id: itemId
					}, function (result, status) {
						window.location.reload();
					});
				}

				return false;
			});
		})();

		// SIDEBAR CATALOG FILTER HANDLERS
		(function () {
			if (!$('.catalog_filter').length) {
				return;
			}

			const $filterShadow = $('.catalog_filter_shadow');
			const $filterBar = $('.catalog_filter');

			$('.handler-open-filterbar').click(function () {
				$filterShadow.show();
				$filterBar.fadeIn();
				return false;
			});

			$filterBar.find('.handler-close-filterbar').click(function () {
				$filterBar.fadeOut(function () {
					$filterShadow.hide();
				});
				return false;
			});

			$filterBar.find('._filter_item_range .range_slider').each(function (index, element) {
				const $element = $(element);
				const $container = $element.closest('._filter_item_range');

				if ($container.data('min') === '%min%' || $container.data('max') === '%max%') {
					$container.remove();
				}

				$element.ionRangeSlider({
					skin: 'square',
					type: 'double',
					step: 100,
					min: $container.data('min'),
					max: $container.data('max'),
					from: $container.data('from'),
					to: $container.data('to'),
					hide_from_to: false,
					hide_min_max: true,

					scope: $element,
					onChange(slider) {
						$container.find('.__val_from').val(slider.from);
						$container.find('.__val_to').val(slider.to);
					}
				});

				//$element.data("ionRangeSlider").reset();
			});

			$filterBar.find('.catalog_filter_item_list li').each(function (index, element) {
				const $element = $(element);
				$element.click(function () {
					if ($element.hasClass('active')) {
						$element.removeClass('active');
						$element.find('input').prop('name', '').val('');
					}else {
						$element.addClass('active');
						$element.find('input').prop('name', $element.data('rel')).val($element.data('value'));
					}
					return false;
				});
				if ($element.data('checked') === 1) {
					$element.addClass('active');
					$element.find('input').prop('name', $element.data('rel')).val($element.data('value'));
				}
			});

			$filterBar.find('.handler-filter-submit').click(function () {
				const $this = $(this);
				if ($this.hasClass('_waiting')) {
					return false;
				}

				$this.addClass('_waiting');
				$this.data('initial-text', $this.text()).text(window.langEn ? 'Pls wait...' : 'Подождите...');

				$this.closest('form').get(0).submit();

				return false;
			});

			const $filterSummary = $('.catalog .catalog_filter_summary').empty();
			$filterBar.find('.catalog_filter_item').each(function (index, filterItem) {
				const $filterItem = $(filterItem);
				if ($filterItem.hasClass('_filter_item_range')) {
					if ($filterItem.data('from') !== $filterItem.data('min') || $filterItem.data('to') !== $filterItem.data('max')) {
						$filterSummary.append($('<a>').addClass('catalog_filter_summary_item').attr({
							title: window.langEn ? 'Reset filter' : 'Сбросить данный фильтр',
							href: '#'
						}).text($filterItem.data('from') + ' Р - ' + $filterItem.data('to') + ' Р').click(function () {
							$filterItem.find('.__val_from').val($filterItem.data('min'));
							$filterItem.find('.__val_to').val($filterItem.data('max'));
							$filterItem.closest('form').get(0).submit();
							return false;
						}));
					}
				}else if ($filterItem.hasClass('_filter_item_dictionary')) {
					let selected = [];
					$filterItem.find('li.active').each(function (index2, selectedItem) {
						const $selectedItem = $(selectedItem);
						selected.push($selectedItem.data('value'));
					});
					if (selected.length) {
						$filterSummary.append($('<a>').addClass('catalog_filter_summary_item').attr({
							title: window.langEn ? 'Reset filter' : 'Сбросить данный фильтр',
							href: '#'
						}).text(selected.join(', ')).click(function () {
							$filterItem.find('li.active').removeClass('active').find('input').prop('name', '').val('');
							$filterItem.closest('form').get(0).submit();
							return false;
						}));
					}
				}
			});

			if ($filterSummary.find('a').length) {
				$filterSummary.append($('<a>').addClass('catalog_filter_summary_all').attr({
					title: window.langEn ? 'Reset all filters' : 'Сбросить все фильтры',
					href: '#'
				}).text(window.langEn ? 'Clear all' : 'Очистить всё').click(function () {
					window.location.href = $filterBar.find('form').attr('action');
					return false;
				}));
			}
		})();


		// PRODUCT
		(function () {
			if (!$('.product').length) {
				return;
			}

			const $productContainer = $('.product');

			if ( !window.sys.checkIsMobile()) {
				$productContainer.find('.product_media_photo').colorbox({
					maxWidth: '90%',
					maxHeight: '90%'
				});
			}

			const $sizesList = $productContainer.find('.product_sizes_list');
			if ($sizesList.data('opt-id') && $sizesList.data('opt-items')) {
				const sizesItems = $sizesList.data('opt-items').split('|');
				for (let iter = 0; iter < sizesItems.length; iter++) {
					if (sizesItems[iter]) {
						$sizesList.find('li[rel=' + sizesItems[iter] + ']').removeClass('unavailable');
					}
				}
			}
			$sizesList.find('li').click(function () {
				const $this = $(this);
				if ($this.hasClass('unavailable')) {
					return false;
				}

				$('.product .product_sizes_list li').removeClass('active').removeClass('error');
				$this.addClass('active');

				return false;
			});

			$productContainer.find('.handler-product-add-to-favorite').click(function () {
				const $this = $(this);
				if ($this.hasClass('_waiting')) {
					return false;
				}

				const itemId = $this.data('item-id');
				if (itemId) {
					$this.addClass('_waiting');

					$.get('/_sys/add-to-bookmarks/', {
						page_id: itemId
					}, function (result, status) {
						const $result = $(result);
						const $headerToolFavorite = $('.header_tools_item._favorites');

						const $item = $this;
						const $temporary = $('<div>').css({
							position: 'absolute',
							top: $item.offset().top,
							left: $item.offset().left,
							width: $item.width(),
							height: $item.height()
						}).appendTo($('body')).append($item.clone().addClass('_temporary').addClass('_animate'));

						$temporary.animate({
							top: $headerToolFavorite.offset().top,
							left: $headerToolFavorite.offset().left
						}, 950, 'swing', function () {
							$headerToolFavorite.find('span').text($result.text()).show();
							$temporary.remove();
							$this.removeClass('_waiting');
						});
					});
				}

				return false;
			});

			$productContainer.find('.handler-open-credit-info').click(function () {
				const $this = $(this);
				$this.closest('.product_credit_info').find('.product_credit_info_block').show();

				return false;
			});

			$productContainer.find('.handler-close-credit-info').click(function () {
				const $this = $(this);
				$this.closest('.product_credit_info_block').hide();

				return false;
			});

			$productContainer.find('.product_description_item_title').click(function () {
				const $this = $(this);
				$this.toggleClass('open').closest('.product_description_item').find('.product_description_item_content').slideToggle();
				return false;
			});

			$productContainer.find('.product_instagramm_list a').each(function (index, element) {
				const $element = $(element);
				if ($element.attr('href')) {
					$element.attr({
						target: '_blank'
					});
				}else {
					$element.attr({
						href: $element.data('big'),
						rel: 'product_instagramm'
					}).addClass('product_instagramm_list_big');
				}
			});
			$productContainer.find('.product_instagramm_list_big').colorbox({
				maxWidth: '90%',
				maxHeight: '90%'
			});

			$productContainer.find('.handler-product-add-to-cart').click(function () {
				const $this = $(this);
				if ($this.hasClass('_completed')) {
					return true;
				}
				if ($this.hasClass('_waiting')) {
					return false;
				}

				const itemId = $this.data('item-id');
				if (itemId) {
					if ($productContainer.find('.product_sizes_list li').length && !$productContainer.find('.product_sizes_list li.active').length) {
						$productContainer.find('.product_sizes_list li').addClass('error');
						return false;
					}

					$this.addClass('_waiting');
					$this.data('initial-text', $this.text()).text(window.langEn ? 'Pls wait...' : 'Подождите...');

					let options = {};

					const $selectedSize = $productContainer.find('.product_sizes_list li.active');
					if ($selectedSize.length) {
						options[$productContainer.find('.product_sizes_list').data('opt-name')] = $selectedSize.attr('rel');
					}

					basket.putElement(itemId, options, function (result) {
						$this.removeClass('_waiting').addClass('_completed');
						$this.text(window.langEn ? 'Added to cart' : 'В корзине').attr({
							title: window.langEn ? 'Go to shopping cart' : 'Перейти в корзину'
						});
						$('.header_tools_list ._cart span').show().text(result.summary.amount);
						window.currentElementAddedToCart = itemId;
					});
				}

				return false;
			});

		})();


		// LOOK
		(function () {
			if (!$('.look').length) {
				return;
			}

			window.currentElementAddedToCart = 0;

			const $container = $('.look');
			const $modalLook = $modals.find('.modal__look');

			function recalculateLookPrice() {
				let totalPrice = 0;
				$container.find('.look_item').each(function (index, item) {
					const $item = $(item);
					if ($item.hasClass('checked')) {
						totalPrice += parseFloat($item.data('price').toString().replace(/\s+/g, ''));
					}
				});
				$container.find('.look_summary_total').text(
					window.currUsd ?
						formatMoney(totalPrice, 2, '.', ' ') :
						formatMoney(totalPrice, 0, '', ' ')
				);
				if ( !totalPrice) {
					$container.find('.look_buttons .btn').addClass('disabled');
				}else {
					$container.find('.look_buttons .btn').removeClass('disabled');
				}
			}

			$container.find('.look_item .look_item_image').click(function () {
				if ($container.find('.look_buttons .btn').hasClass('_completed')) {
					return false;
				}

				const $item = $(this).closest('.look_item');
				$item.toggleClass('checked');

				recalculateLookPrice();

				return false;
			});

			$container.find('.look_buttons .btn').click(function () {
				if ($(this).hasClass('_completed')) {
					return true;
				}
				if ( !$container.find('.look_item.checked').length) {
					return false;
				}

				showModal('modal__look');

				$modalLook.find('.look_item').hide();
				$container.find('.look_item.checked').each(function (index, item) {
					const $item = $(item);
					const elementId = $item.data('element-id');

					if (elementId) {
						const $element = $modalLook.find('.look_item.__eid' + elementId).show();
						if (window.currentElementAddedToCart && window.currentElementAddedToCart == elementId) {
							$element.find('.look_item_sizes_label').text(window.langEn ? 'Already in the cart' : 'Уже в корзине');
							$element.find('.look_item_sizes_list').hide();
						}
					}
				});

				$modalLook.find('.look_total_summ').text($container.find('.look_summary_total').text());

				return false;
			});

			$modalLook.find('.look_item_sizes_list').each(function (index, sizesList) {
				const $sizesList = $(sizesList);
				if ($sizesList.data('opt-id') && $sizesList.data('opt-items')) {
					const sizesItems = $sizesList.data('opt-items').split('|');
					for (let iter = 0; iter < sizesItems.length; iter++) {
						if (sizesItems[iter]) {
							$sizesList.find('li[rel=' + sizesItems[iter] + ']').removeClass('unavailable');
						}
					}
				}
				$sizesList.find('li').click(function () {
					const $this = $(this);
					if ($this.hasClass('unavailable')) {
						return false;
					}

					$sizesList.find('li').removeClass('active');
					$sizesList.prev('.look_item_sizes_label').removeClass('error');
					$this.addClass('active');

					return false;
				});
			});

			$modalLook.find('.handler-add-look-to-cart').click(function () {
				const $this = $(this);
				if ($this.hasClass('_completed')) {
					return true;
				}
				if ($this.hasClass('_waiting')) {
					return false;
				}

				let error = false;
				$modalLook.find('.look_item:visible').each(function (index, item) {
					const $item = $(item);
					if (window.currentElementAddedToCart && window.currentElementAddedToCart == $item.data('element-id')) {
						return;
					}
					if ($item.find('.look_item_sizes_list li').length && !$item.find('.look_item_sizes_list li.active').length) {
						error = true;
						$item.find('.look_item_sizes_label').addClass('error');
					}
				});
				if (error) {
					return false;
				}

				$this.addClass('_waiting');
				$this.data('initial-text', $this.text()).text(window.langEn ? 'Pls wait...' : 'Подождите...');

				let amountItems = $modalLook.find('.look_item:visible').length;
				let basketRequests = [];

				$modalLook.find('.look_item:visible').each(function (index, item) {
					const $item = $(item);
					const itemId = $item.data('element-id');
					if (window.currentElementAddedToCart && window.currentElementAddedToCart == itemId) {
						amountItems--;
						return;
					}

					let options = {};

					const $selectedSize = $item.find('.look_item_sizes_list li.active');
					if ($selectedSize.length) {
						options[$item.find('.look_item_sizes_list').data('opt-name')] = $selectedSize.attr('rel');
					}

					basketRequests.push({itemId, options});
				});

				const basketRequest = function () {
					if (basketRequests.length) {
						const request = basketRequests.shift();
						basket.putElement(request.itemId, request.options, function (result) {
							$('.header_tools_list ._cart span').show().text(result.summary.amount);
							basketRequest();
						});
					}else {
						$this.removeClass('_waiting').addClass('_completed');

						$container.find('.look_buttons .btn').addClass('_completed').text(window.langEn ? 'Added to cart' : 'В корзине').attr({
							title: window.langEn ? 'Go to shopping cart' : 'Перейти в корзину'
						});

						$modalLook.hide();
						$modalsBackdrop.hide();
						$modals.hide();
					}
				};

				basketRequest();

				return false;
			});

			recalculateLookPrice();
		})();


		// CART
		(function () {
			if (!$('.cart').length) {
				return;
			}

			const $container = $('.cart');

			const modifyCartItemAmount = function ($element, $input, amount) {
				if (amount === 0) {
					basket.modifyItem($element.data('id'), {amount}, function () {
						window.location.reload();
					});
				}else {
					basket.modifyItem($element.data('id'), {amount}, function (data) {
						$input.val( amount );

						$('._total_price_actual').text(
							window.currUsd ?
								formatMoney(data.summary.price.actual, 2, '.', ' ') :
								formatMoney(data.summary.price.actual, 0, '', ' ')
						);
						if (data.summary.price.discount) {
							$('._total_price_discount').text(
								window.currUsd ?
									formatMoney(data.summary.price.discount, 2, '.', ' ') :
									formatMoney(data.summary.price.discount, 0, '', ' ')
							);
						}
						$('.header_tools_list ._cart span').text(data.summary.amount);

						if ($element.find('.cart_item_price_old').length) {
							let oldPrice = $element.find('.cart_item_price_old').data('initial').toString().replace(/\s/g, '');
							if (oldPrice) {
								$element.find('.cart_item_price_old').text(
									window.currUsd ?
										formatMoney(parseInt($input.val()) * parseFloat(oldPrice), 2, '.', ' ') :
										formatMoney(parseInt($input.val()) * parseInt(oldPrice), 0, '', ' ')
								);

							}
						}

						for (let ind in data.items.item) {
							const object = data.items.item[ind];
							if (object && object.id) {
								if (object.id === $element.data('id')) {
									$element.find('.cart_item_price_current').text(
										window.currUsd ?
											formatMoney(object['total-price'].actual, 2, '.', ' ') :
											formatMoney(object['total-price'].actual, 0, '', ' ')
									);
								}
							}
						}
					});
				}
			};

			$container.find('.cart_item').each(function (index, element) {
				const $element = $(element);
				const $input = $element.find('.cart_item_amount input');

				if ($element.find('.cart_item_price_old').length) {
					let oldPrice = $element.find('.cart_item_price_old').data('initial').toString().replace(/\s/g, '');
					if (oldPrice) {
						$element.find('.cart_item_price_old').text(
							window.currUsd ?
								formatMoney(parseInt($input.val()) * parseFloat(oldPrice), 2, '.', ' ') :
								formatMoney(parseInt($input.val()) * parseInt(oldPrice), 0, '', ' ')
						);
					}
				}

				$element.find('.handler-cart-amount-minus').click(function () {
					const amount = parseInt($input.val()) - 1;
					modifyCartItemAmount($element, $input, amount);

					return false;
				});

				$element.find('.handler-cart-amount-plus').click(function () {
					const amount = parseInt($input.val()) + 1;
					modifyCartItemAmount($element, $input, amount);

					return false;
				});
			});

			$container.find('.cart_promocode input[type=text]').focus(function () {
				const $this = $(this);
				const $wrapper = $this.closest('.cart_promocode');
				$wrapper.removeClass('error');
			});

			$container.find('.cart_promocode .cart_promocode_plus').click(function () {
				const $this = $(this);

				if ($this.hasClass('_waiting')) {
					return false;
				}

				const $wrapper = $this.closest('.cart_promocode');
				const $input = $wrapper.find('input');

				if ( !$input.val().trim().length) {
					$wrapper.addClass('error');
					return false;
				}

				$wrapper.find('span').text('');
				$this.addClass('_waiting');

				$.ajax({
					type: 'POST',
					dataType: 'json',
					url: '/udata/emarket/savePromoCode/.json',
					data: {
						promocode: $input.val().trim()
					},
					success: function (data) {
						if (data.result) {
							window.location.reload();
						}else {
							$wrapper.find('span').text(window.langEn ? 'Invalid coupon' : 'Неверный промокод');
							$input.val('');
							$this.removeClass('_waiting');
						}
					}
				});

				return false;
			});
		})();



		// PURCHASE
		(function () {
			if (!$('.purchase').length) {
				return;
			}

			const deliveryId_Self		= 857;
			const deliveryId_CDEKSpb	= 1989;
			const deliveryId_CDEKRussia	= 1990;
			const deliveryId_CDEKCIS	= 1991;
			const deliveryId_RussPost	= 1993;
			const deliveryId_EMS		= 1994;

			const deliveryId_BoxberryRussia		= 7973;
			const deliveryId_PickPointRussia	= 7975;

			const paymentId_Self		= 856;
			const paymentId_Courier		= 3756;

			const countryId_Russia		= 10;



			const $form = $('.purchase_form');
			const $deliveryGroup = $form.find('._delivery_group');
			const $addressGroup = $form.find('._address_group');
			const $paymentGroup = $form.find('._payment_group');

			let paymentMethodId = 0;
			let deliveryMethodId = 0;

			$form.find('.form_input').each(function (index, input) {
				const $input = $(input);
				if ($input.data('required') === '*') {
					$input.addClass('required');
				}

				$input.find('input[type=text], input[type=number], textarea').focus(function () {
					$input.addClass('typed').removeClass('error');
				}).focusout(function () {
					const $this = $(this);
					if ( !$this.val().trim().length) {
						$this.val('');
						$input.removeClass('typed');
					}
				});

				$input.find('select').focus(function () {
					$input.addClass('typed').removeClass('error');
				}).focusout(function () {
					const $this = $(this);
					if ( !$this.val().trim().length) {
						$input.removeClass('typed');
					}else if ( !$input.hasClass('typed')) {
						$input.addClass('typed');
					}
				}).change(function () {
					const $this = $(this);
					if ( !$this.val().trim().length) {
						$input.removeClass('typed');
					}else if ( !$input.hasClass('typed')) {
						$input.addClass('typed');
					}
				});

				$input.find('label').click(function () {
					$input.find('input[type=text], input[type=number], textarea').first().trigger('focus');
					$input.find('select').first().trigger('focus').trigger('click');
					return false;
				});
			});

			$form.find('.form_radio').click(function () {
				const $this = $(this);
				if ($this.hasClass('checked')) {
					return;
				}

				const $group = $this.closest('.form_radio_group');
				if ($group.length) {
					$group.find('.form_radio_group_message').hide();
					$group.find('.form_radio').removeClass('checked');
					$group.find('> input[type=hidden]').val($this.data('val'));
					$this.addClass('checked');

					if ($group.closest('.form_section').hasClass('_delivery_group')) {
						deliveryMethodId = $this.data('val');
						processDeliveryChange($this.data('val'), $this.data('option-price'));
					} else if ($group.closest('.form_section').hasClass('_payment_group')) {
						paymentMethodId = $this.data('val');
					}
				}
			});

			const processDeliveryChange = function (deliveryId, deliveryPrice) {
				const $paymentSelf = $paymentGroup.find('.form_radio._dict_item_' + paymentId_Self);
				const $paymentCourier = $paymentGroup.find('.form_radio._dict_item_' + paymentId_Courier);

				const $deliveryTotalFree = $('.purchase_total_delivery_free');
				const $deliveryTotalPay = $('.purchase_total_delivery_pay');

				if (deliveryPrice && parseInt(deliveryPrice)) {
					$deliveryTotalFree.hide();
					$deliveryTotalPay.show().find('._delivery_price').text(
						window.currUsd ?
							formatMoney(deliveryPrice, 2, '.', ' ') :
							formatMoney(deliveryPrice, 0, '', ' ')
					);
					$('._total_price_full').text(
						window.currUsd ?
							formatMoney(parseFloat(deliveryPrice) + $('._total_price_full').data('initial'), 2, '.', ' ') :
							formatMoney(parseInt(deliveryPrice) + $('._total_price_full').data('initial'), 0, '', ' ')
					);
				} else {
					$deliveryTotalPay.hide();
					$deliveryTotalFree.show();
					$('._total_price_full').text(
						window.currUsd ?
							formatMoney($('._total_price_full').data('initial'), 2, '.', ' ') :
							formatMoney($('._total_price_full').data('initial'), 0, '', ' ')
					);
				}

				if (deliveryId === deliveryId_Self) {
					$addressGroup.hide();
					if ($paymentSelf.length) {
						$paymentSelf.closest('.form_row').show();
					}
				}else {
					$addressGroup.show();
					if ($paymentSelf.length) {
						if ($paymentSelf.hasClass('checked')) {
							$paymentSelf.removeClass('checked').closest('.form_radio_group').find('> input[type=hidden]').val('');
						}
						$paymentSelf.closest('.form_row').hide();
					}
				}

				if (deliveryId === deliveryId_CDEKSpb) {
					if ($paymentCourier.length) {
						$paymentCourier.closest('.form_row').show();
					}
				} else {
					if ($paymentCourier.length) {
						if ($paymentCourier.hasClass('checked')) {
							$paymentCourier.removeClass('checked').closest('.form_radio_group').find('> input[type=hidden]').val('');
						}
						$paymentCourier.closest('.form_row').hide();
					}
				}

				if (deliveryId === deliveryId_CDEKSpb) {
					$addressGroup.find('._input_country').addClass('typed').addClass('readonly').removeClass('required')
						.find('select').val(countryId_Russia).prop('disabled', true);

					$addressGroup.find('._input_postcode').addClass('typed').addClass('readonly').removeClass('required')
						.find('input').val('').prop('readonly', true);

					$addressGroup.find('._input_region').addClass('typed').addClass('readonly').removeClass('required')
						.find('input').val('Санкт-Петербург').prop('readonly', true);

					$addressGroup.find('._input_city').addClass('required');
					$addressGroup.find('._input_street').addClass('required');
					$addressGroup.find('._input_build').addClass('required');
				}else if (deliveryId === deliveryId_CDEKRussia) {
					$addressGroup.find('._input_country').addClass('typed').addClass('readonly').removeClass('required')
						.find('select').val(countryId_Russia).prop('disabled', true);

					$addressGroup.find('._input_postcode').addClass('typed').addClass('readonly').removeClass('required')
						.find('input').val('').prop('readonly', true);

					$addressGroup.find('._input_region').removeClass('readonly').addClass('required')
						.find('input').prop('readonly', false);

					$addressGroup.find('._input_city').addClass('required');
					$addressGroup.find('._input_street').addClass('required');
					$addressGroup.find('._input_build').addClass('required');
				}else if (deliveryId === deliveryId_CDEKCIS) {
					$addressGroup.find('._input_country').removeClass('readonly').addClass('required')
						.find('select').prop('disabled', false);

					$addressGroup.find('._input_postcode').removeClass('readonly').addClass('required')
						.find('input').prop('readonly', false);

					$addressGroup.find('._input_region').removeClass('readonly').addClass('required')
						.find('input').prop('readonly', false);

					$addressGroup.find('._input_city').addClass('required');
					$addressGroup.find('._input_street').addClass('required');
					$addressGroup.find('._input_build').addClass('required');
				}else if (deliveryId === deliveryId_RussPost) {
					$addressGroup.find('._input_country').removeClass('readonly').addClass('required')
						.find('select').prop('disabled', false);

					$addressGroup.find('._input_postcode').removeClass('readonly').addClass('required')
						.find('input').prop('readonly', false);

					$addressGroup.find('._input_region').removeClass('readonly').addClass('required')
						.find('input').prop('readonly', false);

					$addressGroup.find('._input_city').addClass('required');
					$addressGroup.find('._input_street').addClass('required');
					$addressGroup.find('._input_build').addClass('required');
				}else if (deliveryId === deliveryId_EMS) {
					$addressGroup.find('._input_country').removeClass('readonly').addClass('required')
						.find('select').prop('disabled', false);

					$addressGroup.find('._input_postcode').removeClass('readonly').addClass('required')
						.find('input').prop('readonly', false);

					$addressGroup.find('._input_region').removeClass('readonly').addClass('required')
						.find('input').prop('readonly', false);

					$addressGroup.find('._input_city').addClass('required');
					$addressGroup.find('._input_street').addClass('required');
					$addressGroup.find('._input_build').addClass('required');
				}else if (deliveryId === deliveryId_BoxberryRussia) {
					$addressGroup.find('._input_country').addClass('typed').addClass('readonly').removeClass('required')
						.find('select').val(countryId_Russia).prop('disabled', true);

					$addressGroup.find('._input_postcode').addClass('typed').addClass('readonly').removeClass('required')
						.find('input').val('').prop('readonly', true);

					$addressGroup.find('._input_region').removeClass('readonly').addClass('required')
						.find('input').prop('readonly', false);

					$addressGroup.find('._input_city').addClass('required');
					$addressGroup.find('._input_street').addClass('required');
					$addressGroup.find('._input_build').addClass('required');
				}else if (deliveryId === deliveryId_PickPointRussia) {
					$addressGroup.find('._input_country').addClass('typed').addClass('readonly').removeClass('required')
						.find('select').val(countryId_Russia).prop('disabled', true);

					$addressGroup.find('._input_postcode').addClass('typed').addClass('readonly').removeClass('required')
						.find('input').val('').prop('readonly', true);

					$addressGroup.find('._input_region').removeClass('readonly').addClass('required')
						.find('input').prop('readonly', false);

					$addressGroup.find('._input_city').addClass('required');
					$addressGroup.find('._input_street').addClass('required');
					$addressGroup.find('._input_build').addClass('required');
				}
			};

			$('.handler-purchase-order').click(function () {
				const $this = $(this);
				if ($this.hasClass('_waiting')) {
					return false;
				}

				const $formOrder = $this.closest('form');
				const $formCredit = $('#process_order_form_credit');

				let error = false;
				$formOrder.find('.form_input.required:visible').each(function (index, input) {
					const $input = $(input);
					const value = $input.find('input[type=text], input[type=number], textarea, select').first().val();

					if ( !$input.find('> span').length) {
						$input.append('<span>');
					}

					if ( !value.trim().length) {
						error = true;
						$input.find('> span').text(window.langEn ? 'Field is required' : 'Поле обязательно для заполнения');
						$input.addClass('error');
					}else {
						if ($input.hasClass('__field_email')) {
							const re = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
							if ( !re.test(value)) {
								error = true;
								$input.find('> span').text(window.langEn ? 'Invalid email address' : 'Невалидный email адрес');
								$input.addClass('error');
							}
						}else if ($input.hasClass('__field_phone')) {
							const matches = value.match(/\d/g);
							if ( !matches || matches.length < 7) {
								error = true;
								$input.find('> span').text(window.langEn ? 'Invalid phone number' : 'Невалидный номер телефона');
								$input.addClass('error');
							}
						}
					}
				});

				$formOrder.find('.form_radio_group.required').each(function (index, group) {
					const $group = $(group);
					if ( !$group.find('.form_radio.checked').length) {
						error = true;
						$group.find('.form_radio_group_message').show();
					}
				});

				if (error) {
					return false;
				}

				$this.addClass('_waiting');

				if (paymentMethodId == '1997') {
					const customerEmail = $formOrder.find('input.__field_email').val();
					const customerPhone = $formOrder.find('input.__field_phone').val();
					if (customerEmail) {
						$formCredit.find('input[name="customerEmail"]').val(customerEmail);
					}
					if (customerPhone) {
						$formCredit.find('input[name="customerPhone"]').val(customerPhone);
					}
					$formOrder.ajaxSubmit(function() {
						$formCredit.get(0).submit();
					});
				} else {
					$formOrder.get(0).submit();
				}

				return false;
			});
		})();


		// INNER SIDEBAR
		(function () {
			if ( !$('.inner_sidebar').length) {
				return;
			}

			const $sidebarNavList = $('.inner_sidebar .inner_sidebar_navigation');
			const $content = $('.inner_main .inner_wysiwyg');
			if ($content.hasClass('_noprocess_nav')) {
				return;
			}

			$content.find('h2').each(function (index, header) {
				const $header = $(header);

				let headerId = $header.attr('id');
				if ( !headerId) {
					headerId = '_c_header_' + Math.floor(Math.random() * 10000);
					$header.attr('id', headerId);
				}

				const $link = $('<a>').attr({
					href: '#' + headerId
				}).text($header.text()).click(function () {
					$(window).scrollTo($(this).attr('href'), 1000);
					return false;
				}).appendTo( $('<li>').appendTo($sidebarNavList) );
			});
		})();


		// AJAX FORMS
		(function () {
			$('._ajax_form').each(function (index, form) {
				const $form = $(form);

				$form.find('.form_input').each(function (index, input) {
					const $input = $(input);
					if ($input.data('required') === '*') {
						$input.addClass('required');
					}

					$input.find('input[type=text], input[type=number], input[type=password], textarea').focus(function () {
						$input.addClass('typed').removeClass('error');
					}).focusout(function () {
						const $this = $(this);
						if ( !$this.val().trim().length) {
							$this.val('');
							$input.removeClass('typed');
						}
					});

					$input.find('input[type=text], input[type=number], input[type=password], textarea').each(function (index2, field_input) {
						if ($(field_input).val().length) {
							$input.addClass('typed');
						}
					});

					$input.find('select').focus(function () {
						$input.addClass('typed').removeClass('error');
					}).focusout(function () {
						const $this = $(this);
						if ( !$this.val().trim().length) {
							$input.removeClass('typed');
						}else if ( !$input.hasClass('typed')) {
							$input.addClass('typed');
						}
					}).change(function () {
						const $this = $(this);
						if ( !$this.val().trim().length) {
							$input.removeClass('typed');
						}else if ( !$input.hasClass('typed')) {
							$input.addClass('typed');
						}
					});

					$input.find('label').click(function () {
						$input.find('input[type=text], input[type=number], input[type=password], textarea').first().trigger('focus');
						$input.find('select').first().trigger('focus').trigger('click');
						return false;
					});
				});

				$form.find('.handler-send-form').click(function () {
					const $this = $(this);
					if ($this.hasClass('_waiting')) {
						return false;
					}

					$form.find('.form_error').hide();

					let error = false;
					$form.find('.form_input.required:visible').each(function (index, input) {
						const $input = $(input);
						const value = $input.find('input[type=text], input[type=number], input[type=password], textarea, select').first().val();

						if ( !$input.find('> span').length) {
							$input.append('<span>');
						}

						if ( !value.trim().length) {
							error = true;
							$input.find('> span').text(window.langEn ? 'Field is required' : 'Поле обязательно для заполнения');
							$input.addClass('error');
						}else {
							if ($input.hasClass('__field_email')) {
								const re = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
								if ( !re.test(value)) {
									error = true;
									$input.find('> span').text(window.langEn ? 'Invalid email address' : 'Невалидный email адрес');
									$input.addClass('error');
								}
							}else if ($input.hasClass('__field_phone')) {
								const matches = value.match(/\d/g);
								if ( !matches || matches.length < 7) {
									error = true;
									$input.find('> span').text(window.langEn ? 'Invalid phone number' : 'Невалидный номер телефона');
									$input.addClass('error');
								}
							}
						}
					});

					if (error) {
						return false;
					}

					$this.addClass('_waiting');
					$this.data('initial-text', $this.text()).text(window.langEn ? 'Pls wait...' : 'Подождите...');

					if ($form.hasClass('_ajax_form_classic')) {
						$form.get(0).submit();
					} else {
						let data = {};
						$form.find('input, textarea, select').each(function (index, input) {
							const $input = $(input);
							if ($input.prop('name')) {
								data[$input.prop('name')] = $input.val();
							}
						});

						if ($form.hasClass('_ajax_form_register')) {
							data.email = data.login;
						}

						$.post($form.data('fa'), data, function (result, b, c) {
							if ($form.hasClass('_ajax_form_login')) {
								if (result && typeof result === 'object') {
									if (result.user.type !== 'guest') {
										window.location.href = "/profile/info/";
										return;
									}
								}
								$form.find('.form_error').show();
							}else if ($form.hasClass('_ajax_form_forget')) {
								let error = false;
								if (result && typeof result === 'string') {
									if (result.trim().substr(0, 12) === '<!-- err -->') {
										$form.find('.form_error').empty().append(
											$(result).find('div.messages_one')
										);
										result = false;
										error = true;
									}else if (result.trim().substr(0, 14) === '<!-- redir -->') {
										$form.find('.form_data').hide();
										$form.find('.form_result').show();
										result = false;
									} else {
										result = JSON.parse(result);
									}
								}
								if (result && typeof result === 'object') {
									if (typeof result.code !== 'undefined' && ! result.code) {
										if (result.message) {
											$form.find('.form_error').empty().append(
												$('<div>').addClass('messages_one').text(result.message)
											);
											error = true;
										}
									} else {
										$form.find('.form_data').hide();
										$form.find('.form_result').show();
										result = false;
									}
								}
								if (error) {
									$form.find('.form_error').show();
								}
							}else if ($form.hasClass('_ajax_form_register') || $form.hasClass('_ajax_form_settings')) {
								let error = false;
								if (result && typeof result === 'string') {
									if (result.trim().substr(0, 12) === '<!-- err -->') {
										if ($(result).find('div.messages_one').length) {
											$form.find('.form_error').empty().append(
												$(result).find('div.messages_one')
											);
											error = true;
										}
										result = false;
									}else if (result.trim().substr(0, 14) === '<!-- redir -->') {
										result = false;
									} else {
										result = JSON.parse(result);
									}
								}
								if (result && typeof result === 'object') {
									if (typeof result.code !== 'undefined' &&  ! result.code) {
										if (result.message) {
											$form.find('.form_error').empty().append(
												$('<div>').addClass('messages_one').text(result.message)
											);
										}
										error = true;
									}
								}

								if (error) {
									$form.find('.form_error').show();
								} else {
									window.location.href = "/profile/info/";
									return;
								}
							} else {
								$form.find('.form_data').hide();
								$form.find('.form_result').show();
							}

							$this.removeClass('_waiting');
							$this.text($this.data('initial-text'));
						});
					}

					return false;
				});
			});
		})();


		$('._preview').colorbox({
			maxWidth: '80%',
			maxHeight: '80%'
		});

		/** *****************************************/
	});
})('DEBUG');



// WEBPACK FOOTER //
// ./app/scripts/app.js